var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_menu)?_c('div',[_c('nav',[(_vm.isBelowMd)?_c('NavMobile',{attrs:{"from-ca":true}}):_c('Nav')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }